<div oui-dialog-title>
  Modifier un fichier d'allocation
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="padding-24" [scroll]="false">
  <div class="flex-vertical flex-start gap-24 flex-center justify-center" *ngIf="!isloading">
    <div class="files-container" *ngIf="fakeCurrentFile">
      <oui-file-item
        [file]="fakeCurrentFile"
        (delete)="deleteCurrentFile($event)"
        (fileClick)="onCurrentFileClick($event)"></oui-file-item>
    </div>
    <ng-container *ngIf="!fakeCurrentFile">
      <oui-file-uploader
        class="width-100pc"
        type="single"
        accept=".pdf"
        [(value)]="files"
        [maxFileSize]="5"
        hint="Fichiers supportés : pdf / Taille max : 5 Mo"
        (valueChange)="onFileChange($event)">
      </oui-file-uploader>
      <div class="files-container" *ngIf="(files?.length ?? 0) > 0">
        <oui-file-item *ngFor="let file of files" [file]="file" (delete)="deleteFile(file)"></oui-file-item>
      </div>
    </ng-container>
  </div>
  <div class="flex-horizontal flex-center justify-center">
    <oui-loading *ngIf="isloading"></oui-loading>
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  <div class="margin-top-16 gap-8">
    <oui-button type="text" class="flex-none" oui-dialog-close> Annuler </oui-button>
    <oui-button
      type="contained"
      class="flex-none"
      (click)="onValid()">
      Valider
    </oui-button>
  </div>
</oui-dialog-actions>
